import styled from 'styled-components'

const SectionHeader = styled.div`
   margin-bottom: 2rem;
   text-align: ${({ center }) => center && 'center'};
`
export default SectionHeader
